import { create } from 'zustand';

interface DocsSearchStore {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export const useDocsSearchStore = create<DocsSearchStore>(set => ({
  open: false,
  setOpen: open => set({ open }),
}));
